import React from "react";
import { PropTypes } from 'prop-types';
import { Col, Affix } from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Stepper from "../Stepper/Stepper";
import {
  SubHeading,
  PagesHeadingWrapper,
  StepFlexRowMargin
} from "./styles";
import StepOneSetup from "./Components/StepOneSetup";
import {
  updateActiveFlow,
  updateActivePage,
  updateStepperConfig,
  fetchAccountData,
  updateActivePageStepNumber,
  fetchDropdownValues
} from "../../../../actions/globalActions";
import { getZipCode } from "../actions";
import Step2Main from "../Step2LegacyOptions/Step2Main";
import {
  updateActivePageStepName,
  jsonTemp,
  isSecondaryAdvisor
} from "../actions";
import Step3MainPage from "../Step3Review_Submit/MainPage";
import { ConfirmationMessageStep2 } from "../AccountCreated/styles";
import { getPrimaryAccount,getAccountData } from "../../../../utils/sessionUtil";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { FixedWidth } from "../../../../CommonComponents/commonStyles";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { ContentProvider, Types, ContentMessage }  from "../../../../CommonComponents/ContentMessages";

export class NpaSetUpAccount extends React.Component {
  constructor(props) {
    super(props);

    this.newTabIndex = 0;
    this.state = {
      primaryAdvisor: {},
      secondaryAdvisor: {}
    };
  }

  componentWillMount() {
    const stepConfiguration = {
      stepperConfig: [
        {
          key: 1,
          description: "Provide account information",
          status: "process",
          route: "/open-an-additional-account/account-information/",
          pageName: "step1Setup"
        },
        {
          key: 2,
          description: "Legacy options",
          status: "wait",
          route: "/open-an-additional-account/legacy-options/",
          pageName: "step2Legacy"
        },
        {
          key: 3,
          description: "Review and Submit",
          status: "wait",
          route: "/open-an-additional-account/review/",
          pageName: "step3Review"
        }
      ]
    };

    this.props.setStepperConfig(stepConfiguration);
    this.props.setActiveFlow("npaForm");
    this.props.setActivePage("npaFormReducer");
  }
  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/",
      },
      {
        routeName: "Open Account",
        path: ""
      }
    ];
  };

  generateUserDetailsAndDropdowns(){
    const data = {
      metaData: {
        method: "GET",
        page: "NPAccount",
        url: {
          userDetails: `/donor-portal/api/profile/${
            getPrimaryAccount().userId
            }/getAccountProfileByAccountIdAndPartyId?partyId=${getAccountData().partyId}`,
          dropDownValues: "/donor-portal/api/dropDownValues/getCodeValueMapping"
        }
      }
    };
    this.props.getOPABasicinfo(data);

    this.props.fetchDropdownValues({
      metaData: [
        {
          method: "GET",
          page: "NPAccount",
          url: `/DP/Relationship/Types`,
          isBhoomiUrl:true
        }
      ]
    });
  }


  componentDidUpdate(){
    if(this.props.loader){
      this.generateUserDetailsAndDropdowns();
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.generateUserDetailsAndDropdowns();
    window.addEventListener("scroll", this.handleScroll);
    this.props.setActivePageStepNumber(1);
    this.props.setActivePageStepName("step1Setup");
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {
    let body = document.body;
    let html = document.documentElement;
    let height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    let finalHeight = height - window.pageYOffset;
    if (document.querySelector(".ant-affix")) {
      if (finalHeight === 950 || finalHeight < 950) {
        document.querySelector(".ant-affix").style.position = "absolute";
        document.querySelector(".ant-affix").style.removeProperty("top");
        document.querySelector(".ant-affix").style.bottom = "1px";
      } else {
        document.querySelector(".ant-affix").style.position = "fixed";
        document.querySelector(".ant-affix").style.removeProperty("bottom");
        document.querySelector(".ant-affix").style.top = "15px";
      }
    }
  };

  setStepNum = () => {
    this.props.setActivePageStepNumber(1);
  };

  mainHeading = "Set up your additional account";

  setTitle = (title) => {
    this.mainHeading = title;
  }

  render() {
    window.scrollTo(0, 0);
    if(this.props.loader){
      return (
      <div>
        <div className="loadingContainer">
          <div />
          <Preloader />
        </div>
      </div>
      )
    }
    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION,Types.PAGE_PDF_LINKS]} pages={['OOA']}>
        <FixedWidth>
          <div className="fluid-npa">
           <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
            <PagesHeadingWrapper>
              <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="OOA" property="field_page_title" defaultMessage={<Preloader styling={'btnLoader'}/>} setTitle={this.setTitle} />
            </PagesHeadingWrapper>
            <SubHeading>
              <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} html={true} page="OOA" property="description__value" />
            </SubHeading>
            {this.props.stepNum === 2 || this.props.stepNum === 3 ? (
              <ConfirmationMessageStep2>
                Your philanthropic account is almost ready! 
              </ConfirmationMessageStep2>
            ) : null}
            <StepFlexRowMargin>
              <Col lg={{ span: 4 }}>
                <Affix offsetTop={10}>
                  <Stepper className="stepper" />
                </Affix>
              </Col>
              <Col lg={{ span: 20, offset: 1 }}>
                <ContentProvider types={[Types.SUB_HEADING_LEGACY_OPTIONS]} pages={['Legacy options']}>
                  {this.props.history.location.pathname === "/open-an-additional-account/account-information/" && (
                    <>
                      {this.setStepNum()}
                      <StepOneSetup location={this.props.location} />
                    </>
                  )}
                  {this.props.history.location.pathname === "/open-an-additional-account/legacy-options/" && <Step2Main /> }
                  {this.props.history.location.pathname === "/open-an-additional-account/review/" &&  <Step3MainPage /> }
                </ContentProvider>
              </Col>
            </StepFlexRowMargin>
          </div>
        </FixedWidth>
      </ContentProvider>
    );
  }
}

NpaSetUpAccount.propTypes = {
  getOPABasicinfo: PropTypes.func,
  getZipCode: PropTypes.func,
  isSecondaryAdvisor: PropTypes.func,
  isStep1Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  loader: PropTypes.bool,
  setActiveFlow: PropTypes.func,
  setActivePage: PropTypes.func,
  setActivePageStepName: PropTypes.func,
  setActivePageStepNumber: PropTypes.func,
  setStepperConfig: PropTypes.func,
  staticContext: PropTypes.any,
  stepCount: PropTypes.string,
  stepNum: PropTypes.number,
  tempData: PropTypes.any
};

const mapStateToProps = state => ({
  stepCount: state.getIn(["npaFormReducer", "activePageStepName"]),
  stepNum: state.getIn(["globalState", "activePageStepNumber"]),
  isStep1Edit: state.getIn([
    "npaFormReducer",
    "isStep1Edit",
    "isStep1Edit",
    "isStep1Edit"
  ]),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"]),
  loader: state.getIn(["npaFormReducer","apiLoader"])
});

export const mapDispatchToProps = dispatch => ({
  setActiveFlow: flowName => dispatch(updateActiveFlow(flowName)),
  setActivePage: pageName => dispatch(updateActivePage(pageName)),
  setStepperConfig: config => dispatch(updateStepperConfig(config)),
  getOPABasicinfo: data => dispatch(fetchAccountData(data)),
  getZipCode: data => dispatch(getZipCode(data)),
  setActivePageStepNumber: stepNumber =>
    dispatch(updateActivePageStepNumber(stepNumber)),
  setActivePageStepName: stepName =>
    dispatch(updateActivePageStepName(stepName)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  isSecondaryAdvisor: val => dispatch(isSecondaryAdvisor(val)),
  fetchDropdownValues: data => dispatch(fetchDropdownValues(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(NpaSetUpAccount)
);
